// repository.ts
import { getApiClient } from '@mit/aws-vue';
import { TravelApi } from '../api/TravelApi';
import { STAGE_CONFIG } from '../config';

const travelRepository = getApiClient(TravelApi, 'travel');

export default travelRepository;